module.exports = __webpack_public_path__ + "static/img/temple-size.7b81b30.png";


//////////////////
// WEBPACK FOOTER
// ./static/assets/img/FamilyImages/temple-size.png
// module id = 359
// module chunks = 4